// extracted by mini-css-extract-plugin
module.exports = {"programStyle":"_1XYsPkhLaPRhhRpgJ7Idis","programCompletedInfoBoxStyle":"LIDBA9SXiuFPEPJ-eRxh0"};